import React from "react";

export default function (field) {
  const { className } = field;
  const { selectClassName } = field;

  const errors = (field) => {
    const error = field.meta.error;
    const errorPresent = error && field.meta.touched;

    if (errorPresent && typeof error === "string") {
      return <div className="donation-error">{field.meta.error}</div>;
    } else if (errorPresent && Array.isArray(error) === true) {
      return (
        <div>
          {error.map((err, index) => (
            <div key={`${err}-${index}`} className="donation-error">
              {err}
            </div>
          ))}
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={className}>
      <select
        data-testid="t-Select-select"
        className={selectClassName}
        aria-label={field["aria-label"]}
        {...field.input}>
        {field.children}
      </select>
      {errors(field)}
    </div>
  );
}
